/**
 * Shared toggle styling constants.
 * Used by all toggle components for consistent neutral gray styling.
 *
 * Active state: neutral gray (bg-gray-200 light, bg-gray-700 dark)
 * Inactive state: neutral gray text with hover states
 */
export const TOGGLE_STYLES = {
    /** Container styling: border, background, padding, rounded corners */
    container:
        'inline-flex rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-secondary p-1',

    /** Active button styling: neutral gray background with contrasting text */
    active: 'bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-white',

    /** Inactive button styling: neutral gray text with hover states */
    inactive: 'text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-dark',

    /** Disabled button styling: dimmed text, no hover, not-allowed cursor */
    disabled: 'text-gray-400 dark:text-gray-500 cursor-not-allowed',
} as const;

/**
 * Common button base styles used across toggle components.
 * Includes transition for smooth state changes.
 */
export const TOGGLE_BUTTON_BASE = 'rounded-md transition-colors' as const;
